import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { PROPERTY_TYPES } from '../../../../constants';
import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

import { SitePropertyOverview } from './PropertyTypes/SitePropertyOverview';
import { BuildingPropertyOverview } from './PropertyTypes/BuildingPropertyOverview';

function hasAdditionalDetails(additionalDetails) {
  // about, internal, external
  const additionalIndices = Object.keys(additionalDetails);
  const validMap = additionalIndices.map(detailIndex => (
    _.map(additionalDetails[detailIndex], (value, key) => {
      if (key === 'description' || key === 'privateGroup') {
        return false;
      }

      if (_.isArray(value) && value.length === 0) {
        return false;
      }

      if (typeof value === 'string') {
        return value.trim() !== '' && value !== 'Unknown' && value !== null && value !== undefined;
      }

      return value !== 0 && value !== null && value !== -1 && value !== undefined;
    })
  ));

  return _.flatten(validMap).includes(true);
}

export function PropertyOverview({
  type,
  property,
}) {
  const isBuilding = type === PROPERTY_TYPES.BUILDINGS;
  const isSite = type === PROPERTY_TYPES.SITES;

  const { additionalDetails, basicInfo } = property;
  const shouldRenderAdditionalDetails = hasAdditionalDetails(additionalDetails);

  return shouldRenderAdditionalDetails ? (
    <section>
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">Property Overview</h4>
      </ViewerPrimaryColorUserStyle>
      <div className="section-body">
        {
          isBuilding &&
          <BuildingPropertyOverview additionalDetails={additionalDetails} basicInfo={basicInfo} />
        }

        {
          isSite &&
          <SitePropertyOverview additionalDetails={additionalDetails} basicInfo={basicInfo} />
        }
      </div>
    </section>
  ) : null;
}

PropertyOverview.propTypes = {
  type: PropTypes.string,
  property: PropTypes.object.isRequired,
};

export default PropertyOverview;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailOverview/OverviewSections/PropertyOverview.js